import React, { useState } from 'react'
import classNames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import { TYPE } from 'component/imageDetail/userDefinedProps'
import { sampleSourceData, sampleTypeData } from 'component/filter/sampleFilterOptions'
import ModuleItem from '../../../../imageDetail/infoView/info/detail/moduleItem'
import MultiItem from '../../../../imageDetail/infoView/info/detail/multiItem'
import styles from './index.module.less'

export default ({ currentImage, onPropIndex, onVisibleChange, }) => {
  const {
    name,
    remarks,
    num,
    price,
    size,
    gender,
    color,
    source,
    type,
    propertyValueDOList
  } = currentImage
  const [isFold, setIsFold] = useState(true)

  const _color = color ? JSON.parse(color) : []

  return <div className={classNames(styles.infoBlock, 'mt32')}>
    <div className={styles.titleLine}>
      <div className={styles.point} />
      <div className={styles.mainTitle}>
        样衣详情
      </div>
      <div className={styles.mainTitleRight}>
        <a
          className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
          onClick={() => {
            onPropIndex(1)
            onVisibleChange(true)
          }}
        >
          <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />编辑
        </a>
      </div>
      <a className={classNames(styles['fold-dynamic'], 'fill-white-bg')} onClick={() => setIsFold(pre => !pre)}>{isFold ? '展开' : '收起'}<Icon type="m-Vxing_xia" style={{ transform: isFold ? undefined : 'rotate(180deg)', transition: 'all 0.3s' }} /></a>
    </div>
    <div className={styles.infoBlockContext} style={{ maxHeight: `${isFold ? '0px' : '10000px'}` }}>
      <ModuleItem label="样衣名称" value={name} />
      <ModuleItem label="样衣描述" value={remarks} />
      <ModuleItem label="样衣数量" value={num} />
      <ModuleItem label="样衣价格" value={`¥ ${price}`} />
      <ModuleItem
        label="样衣尺寸"
        value={size}
        mb12={false}
        style={{ marginBottom: '6px' }}
      />
      <MultiItem label="样衣颜色" values={Array.isArray(_color) ? _color : [_color]} />
      <ModuleItem label="样衣行业" value={gender} />
      <div className={styles.secondTitle} style={{ marginBottom: '12px' }}>
        <div className={styles.title}>样衣特征</div>
        <a
          className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
          onClick={() => {
            onPropIndex(2)
            onVisibleChange(true)
          }}
        >
          <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />编辑</a>
      </div>
      <ModuleItem label="开款计划" value={source ? sampleSourceData.find(m => source == m.value).label : ''} />
      <ModuleItem label="样衣类型" value={type ? sampleTypeData.find(m => type == m.value).label : ''} />
      <div className={styles.secondTitle}>
        <div className={styles.title}>样衣属性</div>
        <a
          className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
          onClick={() => {
            onPropIndex(3)
            onVisibleChange(true)
          }}
        >
          <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />编辑</a>
      </div>
      {propertyValueDOList?.length > 0 ? <div>
        {propertyValueDOList?.map((prop) => {
          if (prop.propertyType === TYPE.MULTIPLE
            || prop.propertyType === TYPE.TAG || (prop.propertyType === TYPE.MEMBER && prop.memberPropertyStructDTO.isMulti)) {
            return <MultiItem label={prop.propertyName} values={prop.propertyType === TYPE.MEMBER ? prop.nameList : prop.values.filter(m => m)} />
          }
          if (prop.propertyType === TYPE.SINGLE) {
            return <ModuleItem label={prop.propertyName} value={prop.values?.join('/')} />
          }
          if (prop.propertyType === TYPE.LINK) {
            return <ModuleItem label={prop.propertyName} value={prop.values.filter(m => m)?.[0] ? <a title={prop.values[0]} href={prop.values[0]} target="_blank" rel="noreferrer">{prop.values[0]}</a> : ''} />
          }
          if (prop.propertyType === TYPE.BOOL) {
            let val = ''
            if (prop.booleanPropertyStructDTO.trueValue == '是') {
              val = prop.values?.[0] == '1' ? '是' : '否'
            } else {
              val = prop.values?.[0] == '1' ? '有' : '无'
            }
            return <ModuleItem label={prop.propertyName} value={val} />
          }
          return <ModuleItem label={prop.propertyName} value={prop.propertyType === TYPE.MEMBER ? (!prop.nameList.length ? '' : prop.nameList) : prop.values.filter(m => m)?.[0]} />
        })}
      </div> : <div style={{ margin: '10px 0px', color: 'var(--m-text-2)' }}>未选择行业，请点击「编辑」选择行业后填写样衣属性</div>}
    </div>
  </div>
}
